<template>
    <div class="l-container-content bg-white">
        <div class="row">
            <div class="col-6">
                <h3>All Bonus</h3>
            </div>
            <div class="col-6 text-right">
                <button @click="showModal()" class="button primary">Create Bonus</button>
            </div>
        </div>
        <div class="row">
            <loader v-show="loading" />
            <vuetable ref="vuetable" :http-options="httpOptions" :api-url="url" :fields="columns" :sort-order="sortOrder" track-by="msisdn" :append-params="moreParams" :per-page="10" @vuetable:pagination-data="onPaginationData" @vuetable:loading="onLoading" @vuetable:loaded="onLoaded">
                <div slot="status" slot-scope="props">
                    <strong :class="{'text-green':props.rowData.bonus_status== 1, 'text-red': props.rowData.bonus_status == 0}"> {{props.rowData.bonus_status | MessageStatus}}</strong>
    
                </div>
                <div slot="action" slot-scope="props">
                    <button class="button edit" id="commentBTN" @click="showEditBonus(props.rowData)" ><i class="fas fa-edit"></i> Edit</button>
                </div>
                <div slot="action" slot-scope="props">
                    
                </div>
    
    
            </vuetable>
        </div>
        <div class="vuetable-pagination ui basic segment grid row">
            <div class="col text-left">
                <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
            </div>
    
            <div class="col-6  text-right">
                <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
    
        </div>
        <b-modal ref="CreateBonusModal" hide-footer title="Create Bonus">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Bonus Name</label>
                    <input type="text" v-model="bonus_name" placeholder="Enter Bonus Name">
                </div>
                <div class="col-6">
                    <label>Bonus Amount</label>
                    <input type="number" v-model="bonus_amount" placeholder="Enter Bonus Amount">
                </div>
    
                <div class="col-6">
                    <label>Bonus Daily Stake</label>
                    <input type="number" v-model="bonus_daily_stake" placeholder="Enter Bonus Stake">
                </div>
                <div class="col-6">
                    <label>Bonus Start</label>
                    <input type="date" v-model="bonus_start">
                </div>
    
                <div class="col-6">
                    <label>Bonus End</label>
                    <input type="date" v-model="bonus_end">
                </div>
                <div class="col-12">
                    <label>Reference Type*</label>
                    <select v-model="reference_type_id">
                                <option value>Select Reference</option>
                                <option v-for="(n,index) in referenceList" :key="index+1" :value="n.id"> {{n.name}}</option>
                        </select>
                </div>
                <div class="col-12">
                    <label>First Message</label>
                    <textarea rows="5" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="message" required />
                </div>
                <div class="col-12">
                    <label>Reward Message</label>
                    <textarea rows="5" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="messageReward" required />
                </div>
    
    
            </div>
            <div class="mb-3">
                <b-button variant="outline-success" block @click="createBonus()" id="sendBTNMessage">Create Bonus</b-button>
            </div>
    
        </b-modal>
        <b-modal ref="EditBonusModal" hide-footer :title="'Edit Bonus  Reference: '+selectedBonus.bonus_id">
            <div v-show="errorcreateStatus">
                <small class="text-red">{{errorsMessage}}</small>
            </div>
            <div class="l-form row">
                <div class="col-12">
                    <label>Bonus Name</label>
                    <input type="text" v-model="selectedBonus.bonus_name" placeholder="Enter Bonus Name">
                </div>
                <div class="col-6">
                    <label>Bonus Amount</label>
                    <input type="number" v-model="selectedBonus.bonus_amount" placeholder="Enter Bonus Amount">
                </div>
    
                <div class="col-6">
                    <label>Bonus Daily Stake</label>
                    <input type="number" v-model="selectedBonus.bonus_daily_stake" placeholder="Enter Bonus Stake">
                </div>
                <div class="col-6">
                    <label>Bonus Start</label>
                    <input type="date" v-model="selectedBonus.bonus_start">
                </div>
    
                <div class="col-6">
                    <label>Bonus End</label>
                    <input type="date" v-model="selectedBonus.bonus_end">
                </div>
                <div class="col-12">
                    <label>Reference Type*</label>
                    <select v-model="selectedBonus.reference_type_id">
                            <option value>Select Reference</option>
                            <option v-for="(n,index) in referenceList" :key="index+1" :value="n.id"> {{n.name}}</option>
                    </select>
                </div>
                <div class="col-12">
                    <label>First Message</label>
                    <textarea rows="5" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="selectedBonus.bonus_1st_message" required />
                </div>
                <div class="col-12">
                    <label>Reward Message</label>
                    <textarea rows="5" class="w-full block border bg-white rounded-md outline-none text-xs" style="width: 100%;" v-model="selectedBonus.bonus_won_message" required />
                </div>
    
    
            </div>
            <div class="mb-3">
                <b-button variant="outline-success" block @click="editBonus()" id="sendBTNMessage">Edit Bonus</b-button>
            </div>
    
        </b-modal>
    </div>
</template>

<style>
td.vuetable-slot {
    overflow: visible !important;
}
</style>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import loader from "@/components/loader";
import store from "../store";
import $ from "jquery";
import numeral from "numeral";
import moment from "moment";

export default {
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        loader
    },
    name: "approvals",
    data() {
        return {
            bonus_name: "",
            bonus_message: "",
            bonus_amount: 0.00,
            bonus_daily_stake: 0.00,
            reference_type_id: "44",
            bonus_end: "",
            bonus_start: "",
            loading: true,
            loadRecord: false,
            selected_data: {},
            url: "https://interactiveapi.chezagame.com/portal/v1/bonus/view",
            httpOptions: {
                headers: {
                    'X-App-Key': '09lib74145Qb3HO6eQTIfsbylRkyuZFT',
                    'X-Authorization-Key': 'ADMIN_APP',
                    'X-Requested-With': 'XMLHttpRequest',
                    'X-Token-Key': this.$cookies.get("accessToken")
                }
            },
            columns: [

                {
                    name: "bonus_id",
                    title: 'Bonus ID',
                    sortField: "bonus_id",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "bonus_name",
                    title: 'Bonus Name',
                    sortField: "bonus_name",
                    titleClass: "center aligned",
                    dataClass: "center aligned"
                },
                {
                    name: "bonus_amount",
                    title: "Amount",
                    sortField: "bonus_amount",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "bonus_daily_stake",
                    title: "Stake",
                    sortField: "bonus_daily_stake",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "name",
                    title: "Type",
                    sortField: "name",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "status",
                    title: "Status",
                    sortField: "status",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "bonus_start",
                    title: "Start",
                    sortField: "bonus_start",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "bonus_end",
                    title: "End",
                    sortField: "bonus_end",
                    titleClass: "",
                    dataClass: ""
                },
                {
                    name: "bonus_created",
                    title: "Date",
                    sortField: "bonus_created",
                    callback: "bonus_created"
                },
                {
                    name:"action",
                    title:"Action"
                }
            ],
            range: "",
            search_match: "",
            loadOnStart: true,
            sortOrder: [{
                field: "bonus_created",
                direction: "desc"
            }],
            is_partial_resulting: false,

            moreParams: {
                start: "",
                filter: "",
                end: ""
            },

            errorcreateStatus: false,
            errorsMessage: "",
            days: 30,
            referenceList: null,
            blastName: "active",
            message: "",
            messageReward:"",
            selectedBonus:{
                bonus_id:"",
                bonus_name:"",
                bonus_amount:"",
                bonus_status:"",
                bonus_daily_stake:"",
                bonus_1st_message:"",
                bonus_won_message:"",
                name:"",
                bonus_start:"",
                bonus_end:""
            }
        };
    },
    mounted() {

        var vm = this;
        if (vm.$cookies.get("role_id") != 1 && vm.$cookies.get("role_id") != 2) {
            vm.$router.push({
                name: "dashboard"
            });
        }
        vm.getReferenceList()
    },
    watch: {
        data(newVal, oldVal) {
            this.$refs.vuetable.refresh();
        },
        range() {
            var start = this.range[0];
            var end = this.range[1];
            start = moment(start).format("YYYY-MM-DD");
            end = moment(end).format("YYYY-MM-DD");
            this.moreParams.start = start;
            this.moreParams.end = end;
            this.$refs.vuetable.refresh();
        }
    },
    methods: {
        showEditBonus(bonus){
            let vm  = this
            vm.selectedBonus = bonus
            vm.$refs['EditBonusModal'].show()
        },
        hideEditBonus(bonus){
            let vm  = this
            vm.$refs['EditBonusModal'].hide()
            this.$refs.vuetable.refresh();
        },
        showModal() {
            this.$refs['CreateBonusModal'].show()
        },
        hideModal() {
            this.$refs['CreateBonusModal'].hide()
            this.$refs.vuetable.refresh();
        },
        dateFilter: function(start, end) {
            var vm = this;

            vm.start = start;
            vm.end = end;

            vm.moreParams.start = start;
            vm.moreParams.end = end;

            this.$refs.vuetable.refresh();

            console.log("start date filter", start);
            console.log("end date filter ", end);
        },
        createdAt: function(value) {
            if (!value) {
                return "-";
            } else {
                return moment(value).format("h:mm a,DD MMM YYYY");
            }
        },
        searchRecord: function() {
            this.loadRecord = true;
            var str = this.search_match;
            var newString = str.indexOf("0") == 0 ? str.substring(1) : str;
            this.moreParams.filter = "254" + newString;
            this.$refs.vuetable.refresh();
        },
        dataManager(sortOrder, pagination) {
            if (this.data.length < 1) return;

            let local = this.data;

            // sortOrder can be empty, so we have to check for that as well
            if (sortOrder.length > 0) {
                console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
                local = _.orderBy(
                    local,
                    sortOrder[0].sortField,
                    sortOrder[0].direction
                );
            }

            pagination = this.$refs.vuetable.makePagination(
                local.length,
                this.perPage
            );
            console.log("pagination:", pagination);
            let from = pagination.from - 1;
            let to = from + this.perPage;

            return {
                pagination: pagination,
                data: _.slice(local, from, to)
            };
        },
        onPaginationData(paginationData) {
            this.$refs.paginationInfo.setPaginationData(paginationData);
            this.$refs.pagination.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onLoading() {
            this.loading = true;
            console.log("loading... show your spinner here");
        },
        onLoaded() {
            this.loading = false;
            console.log("loaded! .. hide your spinner here");
            $(".ui.dropdown").dropdown();
        },
        getReferenceList() {
            let vm = this
            $.get({
                url: store.state.rootUrl + 'portal/v1/reference/view',
                type: "get",
                async: true,
                crossDomain: true,
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                success: function(response, status, jQxhr) {
                    vm.isLoading = false;
                    vm.referenceList = response.data

                },
                error: function(jQxhr, status, error) {
                    vm.isLoading = false;
                    if (jQxhr.responseJSON.data.code == 401) {
                        var errorMessage = jQxhr.responseJSON.data.message;

                        vm.$router.push({
                            name: 'login'
                        });
                    } else {
                        console.log("Error: " + jQxhr.responseJSON.statusDescription)
                    }
                }
            });


        },
        generateUniqueId(length = 10) {
            const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            for (let i = 0; i < length; i++) {
                result += chars.charAt(Math.floor(Math.random() * chars.length));
            }
            return result;
        },
        createBonus() {
            let vm = this
            $("#sendBTNMessage").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'portal/v1/bonus/create',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    bonus_name: vm.bonus_name,
                    bonus_amount: vm.bonus_amount,
                    bonus_daily_stake: vm.bonus_daily_stake,
                    bonus_1st_message: vm.message,
                    bonus_won_message: vm.messageReward,
                    reference_type_id: vm.reference_type_id,
                    bonus_start: vm.bonus_start,
                    bonus_end: vm.bonus_end,
                    uniqueId: vm.generateUniqueId(),
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#sendBTNMessage").text("Create Bonus");
                    if (response.data.code == 200) {
                        vm.hideModal()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#sendBTNMessage").text("Create Bonus");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
        editBonus() {
            let vm = this
            $("#sendBTNMessage").html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'portal/v1/bonus/edit',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json",
                    "X-Token-Key": vm.$cookies.get("accessToken")
                },
                data: JSON.stringify({
                    bonus_id:vm.selectedBonus.bonus_id,
                    bonus_name: vm.selectedBonus.bonus_name,
                    bonus_amount: vm.selectedBonus.bonus_amount,
                    bonus_daily_stake: vm.selectedBonus.bonus_daily_stake,
                    bonus_1st_message: vm.selectedBonus.bonus_1st_message,
                    bonus_won_message: vm.selectedBonus.bonus_won_message,
                    reference_type_id: vm.selectedBonus.reference_type_id,
                    bonus_start: vm.selectedBonus.bonus_start,
                    bonus_end: vm.selectedBonus.bonus_end,
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $("#sendBTNMessage").text("Edit Bonus");
                    if (response.data.code == 200) {
                        vm.hideEditBonus()
                    } else {

                        vm.errorcreateStatus = true;
                        vm.successcreateStatus = false;
                        vm.errorsMessage = response.data.message;
                    }

                },
                error: function(jQxhr, status, error) {
                    $("#sendBTNMessage").text("Edit Bonus");
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.errorcreateStatus = true;
                    vm.successcreateStatus = false;
                    vm.errorsMessage = jQxhr.responseJSON.data.message;
                }
            });
        },
    },
    filters: {

        MessageStatus(value) {
            if (value == 1) {
                return "Active"
            } else if (value == 2) {
                return "Pending"
            } else {
                return "Close"
            }
        },
        formatNumber(value) {
            return numeral(value).format("0,0");
        },
        format_date(value) {
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD')
            } else {
                return ""
            }
        },

    }

};
</script>
